/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Title = styled.div`
  padding: 2rem 0 0 0;
  margin-left: 1rem;
  font-weight: 550;
  color: #7b7b7b;
  font-family: metropolis;
`;

export const IconTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Fondou = styled.div`
  background: ${props => props.color};
  width: 50%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;

export const BodyText = styled.div`
  width: 89%;
  margin: auto;
  margin-top: 0.5rem;
  margin-bottom: 5rem;
  display: flex;
  height: 5vh;
  justify-content: flex-start;
  align-items: flex-start;
  color: #b0b0b0;
  font-family: quicksand;
`;

export const RowIcon = styled.div`
  width: 50%;
  margin-left: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #b0b0b0;
`;

export const TextCourse = styled.div`
  width: 87%;
  display: flex;
  margin-bottom: 1rem;
  justify-content: flex-end;
  align-items: flex-end;
  color: #b0b0b0;
  font-family: quicksand;
`;
